$(function () {
  window.JSONParseData = (text) => {
    try {
      return JSON.parse(text);
    } catch (err) {
      return [];
    }
  };

  // 字段是否VIP限制
  const isVipMap = JSONParseData($("#IsVip").text());

  // 所有案由
  const reasonData = JSONParseData($("#AllReasonData").text());
  // 专门法院
  const specialData = JSONParseData($("#AllSpecialData").text());
  // 篇幅
  const textlenRangeData = JSONParseData($("#AllTextlenRange").text());
  // 审判年份
  const yearData = JSONParseData($("#AllYear").text());
  // 争议焦点
  const zyjdData = JSONParseData($("#AllZyjd").text());
  // 基本案情
  const ajtzData = JSONParseData($("#AllAjtz").text());
  // 地域
  const regionData = JSONParseData($("#AllRegion").text());
  // 审理法院
  const courtData = JSONParseData($("#AllCourtData").text());
  // 审理程序
  const roundOptions = [
    { value: "1", name: "一审" },
    { value: "3", name: "二审" },
    { value: "2", name: "再审" },
    { value: "4", name: "非诉执行审查" },
    { value: "5", name: "复核" },
    { value: "6", name: "刑罚变更" },
    { value: "7", name: "再审审查与审判监督" },
    { value: "8", name: "执行" },
  ];
  // 裁判结果 ------------------
  const resultTypeJSON = JSONParseData($("#AllResultType").text());
  const resultType0Options = resultTypeJSON[0].list.map(({ id, name }) => ({ value: id, name }));
  const resultType1Options = resultTypeJSON[1].list.map(({ id, name }) => ({ value: id, name }));
  const resultType2Options = resultTypeJSON[2].list.map(({ id, name }) => ({ value: id, name }));
  const resultType3Options = resultTypeJSON[3].list.map(({ id, name }) => ({ value: id, name }));
  // 裁判结果 ------------------

  // 当事人
  const sideOptions = [
    { name: "不限", value: "all" },
    { name: "攻方", value: "gf" },
    { name: "守方", value: "sf" },
  ];
  const typeOptions = [
    { name: "不限", value: "不限" },
    { name: "个人", value: "个人" },
    { name: "机构", value: "机构" },
  ];
  // 关键词的 Filed
  const keywordField = ["1", "2", "k", "3", "h", "d", "i", "a", "4", "5", "w", "g", "j", "l", "m"];

  // optionsMap
  const optionsMap = {
    special: specialData,
    region: regionData,
    court: courtData,
    reason: reasonData,
    result_type_0: resultType0Options,
    result_type_1: resultType1Options,
    result_type_2: resultType2Options,
    result_type_3: resultType3Options,
  };

  const getName = (options, value) => options.find((item) => item.value === value)?.name || "";

  function getPath(options, id) {
    for (const node of options) {
      if (node.id === id) return [node.id];
      if (node.children) {
        const path = getPath(node.children, id);
        if (path.length) return [node.id, ...path];
      }
    }
    return [];
  }

  window.searchFormPattern = {
    isGJJS: window.location.href.indexOf("gjss") > -1,

    components: new Map(),
    emitter: useEmitter(),

    // reason: { field: 'reason', label: '案由', value: [] },
    // formData: new Map(),
    formData: [],

    /**
     * 设置表单数据
     * @param {*} data
     * @type { { field: string, value: any } | { field: string, value: any }[] } data 单个对象或对象数组
     * @returns
     */
    setData(data, { directEmitter = false } = {}) {
      if (!data) return;

      data = data instanceof Array ? data : [data];
      this.rebuildData(data).forEach((item) => {
        const field = item.field;

        if (!field) return;

        const isEmpty = this.isEmptyValue(item);

        if (!isEmpty) {
          // 补全 path
          if (["special", "region", "court", "reason"].includes(field)) {
            item.value.forEach((v) => {
              if (!v.path || !v.path.length) {
                v.path = getPath(optionsMap[field], v.id);
              }
            });
          }
        }

        if (field === "gjjs") {
          this.setKeywordData(item);
        } else if (keywordField.includes(field)) {
          if (!isEmpty) {
            this.formData.push(item);
            this.renderKeywordTagItem(item, $("#searchKeywordWrapper"));
          } else {
            /** 不提供外部调用删除 **/
          }
        } else {
          const index = this.formData.findIndex((_) => _.field === field);
          const tagComponent = this.tagComponents.find((_) => _.field === field);
          if (~index) {
            if (isEmpty) {
              this.formData.splice(index, 1);
              tagComponent?.handleDelete();
            } else {
              this.formData[index] = item;
              tagComponent?.handleUpdate(item);
            }
          } else {
            if (!isEmpty) {
              this.formData.push(item);
              this.renderTagItem(item, $("#searchBoxWrapper"));
            }
          }
        }

        if (["reason", "_reason"].includes(field)) {
          this.components.get("reason")?.setValue(item);
          this.components.get("_reason")?.setValue(item);
        } else if (["year", "cprq"].includes(field)) {
          const yearData = this.formData.find((_) => _.field === "year") || {};
          const customData = this.formData.find((_) => _.field === "cprq") || {};
          this.components.get("year")?.setValue(yearData, customData);
          this.components.get("cprq")?.setValue(customData);
        } else {
          this.components.get(field)?.setValue(item);
        }
      });

      if (this.getDataFlat().length) {
        $("#searchButtonWrapper").show();
      } else {
        $("#searchButtonWrapper").hide();
      }

      if (directEmitter) this.directEmitterChange();
      else this.emitterChange();
    },

    setKeywordData(item) {
      const field = item.field;
      /**
       *  
        {
          filed: 'gjjs',
          value: [
            [
              [
                item,
                item,
                { math: '&' }
              ],
              [],
              { math: '&' }
            ],
            [],
            { math: '&' }
          ]
        }
       * 
       */

      const index = this.formData.findIndex((_item) => _item.field === field);
      const renderItemsArr = [];
      if (~index) this.formData.splice(index, 1, item);
      else this.formData.push(item);

      item.value.flat(Infinity).forEach((_) => _.field && renderItemsArr.push(_));

      renderItemsArr.forEach((_) => {
        this.renderKeywordTagItem(_, $("#searchKeywordWrapper"));
      });
    },

    isEmptyValue(item) {
      if (!item) return true;

      const { field, value } = item;
      if (!field) return true;

      if (Array.isArray(value)) return !value.length;
      return !value;
    },

    sliceText(text, length) {
      if (!text) return "";
      if (text.length <= length) return text;
      return text.slice(0, length - 1) + "…";
    },

    rebuildData(data) {
      // 将 result_type 拆分成 result_type_0\result_type_1\result_type_2\result_type_3
      const resultTypeIndex = data.findIndex(
        (item) => item.field === "result_type" && item.value && item.value.length,
      );

      // 如果设置值的时候 有gjjs字段 则忽略其他关键词字段
      if (data.find((item) => item.field === "gjjs")) {
        data = data.filter((item) => !keywordField.includes(item.field));
      }

      if (~resultTypeIndex) {
        const arr = [
          {
            field: "result_type_0",
            label: "裁判结果",
            value: [],
          },
          {
            field: "result_type_1",
            label: "裁判结果",
            value: [],
          },
          {
            field: "result_type_2",
            label: "裁判结果",
            value: [],
          },
          {
            field: "result_type_3",
            label: "裁判结果",
            value: [],
          },
        ];
        const resultTypeValue = data[resultTypeIndex].value;
        resultTypeValue.forEach(({ id }) => {
          const index0 = resultType0Options.findIndex((item) => item.value === id);
          const index1 = resultType1Options.findIndex((item) => item.value === id);
          const index2 = resultType2Options.findIndex((item) => item.value === id);
          const index3 = resultType3Options.findIndex((item) => item.value === id);

          if (~index0)
            arr[0].value.push({ id, text: resultType0Options[index0].name, index: index0 });
          if (~index1)
            arr[1].value.push({ id, text: resultType1Options[index1].name, index: index1 });
          if (~index2)
            arr[2].value.push({ id, text: resultType2Options[index2].name, index: index2 });
          if (~index3)
            arr[3].value.push({ id, text: resultType3Options[index3].name, index: index3 });
        });

        data.splice(resultTypeIndex, 1, ...arr);
      }

      // 如果数组中存在多个相同字段 根据结构合并
      // data = data.reduce((acc, item) => {
      //   const index = acc.findIndex((i) => i.field === item.field);
      //   const existItem = acc[index];
      //   const value = item.value || [];
      //   const _value = existItem?.value || [];

      //   // 树结构的字段['reason', 'region', 'court', 'special'] 使用
      //   if (["reason", "region", "court", "special"].includes(item.field)) {
      //     const options = optionsMap[item.field] || [];
      //     const ins = new TreeTransfer({ data: options });
      //     ins.setValue([...value, ..._value]);
      //     const newValue = ins.getValue().map((item) => ({ ...item, text: item.name }));
      //     if (~index) {
      //       acc[index].value = newValue;
      //     } else {
      //       acc.push(item);
      //     }
      //   } else if (value instanceof Array && !keywordField.includes(item.field)) {
      //     if (~index) {
      //       acc[index].value = [...value, ..._value].reduce((unique, v) => {
      //         if (!unique.some((item) => item === v || item.id === v.id)) {
      //           unique.push(v);
      //         }
      //         return unique;
      //       }, []);
      //     } else {
      //       acc.push(item);
      //     }
      //   } else {
      //     acc.push(item);
      //   }

      //   return acc;
      // }, []);

      return data.flat();
    },

    /**
     * 获取表单数据
     * @returns {Object} 表单数据
     */
    getData(fields) {
      const _returnValue = [];
      if (fields) {
        if (typeof fields === "string") {
          _returnValue.push(this.formData.find((item) => item.field === fields));
        } else if (fields instanceof Array) {
          _returnValue.push(
            ...fields.map((field) => this.formData.find((item) => item.field === field)),
          );
        }
      } else {
        _returnValue.push(...this.formData);
      }
      const returnValue = _returnValue.filter((item) => {
        if (!item) return false;
        if (item.field === "gjjs") {
          return item.value.flat(Infinity).filter((item) => item.field && !this.isEmptyValue(item))
            .length;
        } else return !this.isEmptyValue(item);
      });

      if (typeof fields === "string") return cloneDeep(returnValue[0]);
      return cloneDeep(returnValue);
      // 返回
      // { field, label, value } | { field, label, value }[]
    },

    getDataFlat(fields) {
      const data = this.getData(fields);
      if (fields && typeof fields === "string") return data;

      return data.flatMap((item) => {
        if (item.field === "gjjs") return item.value.flat(Infinity).filter((item) => item.field);
        else return item;
      });
    },

    rest({ directEmitter = false } = {}) {
      this.formData.forEach((item) => {
        const { field } = item;
        if (["reason", "_reason"].includes(field)) {
          this.components.get("reason")?.setValue({ ...item, value: [] });
          this.components.get("_reason")?.setValue({ ...item, value: [] });
        } else if (["year", "judgement_timestamp"].includes(field)) {
          this.components
            .get("year")
            ?.setValue({ ...item, value: [] }, { ...item, value: undefined });
        } else {
          this.components.get(field)?.setValue({ ...item, value: undefined });
        }
      });

      this.formData = [];
      this.tagComponents = [];

      $("#searchKeywordWrapper").empty();
      $("#searchBoxWrapper").empty();
      $("#searchButtonWrapper").hide();

      if (directEmitter) this.directEmitterChange();
      else this.emitterChange();
    },

    register(field, component) {
      if (
        ["reason", "judgement", "case_level", "cprq", "round", "court_level", "special"].includes(
          field,
        )
      ) {
        $('.search-form-layout[data-layout="basic"]').append(component.$html);
      } else if (
        [
          "_reason",
          "all_law_text",
          "region",
          "court",
          "dsr_tag",
          "prosecution_org_tags",
          "judge_tags",
          "lawyer_tags",
          "lawoffice_tags",
        ].includes(field)
      ) {
        $('.search-form-layout[data-layout="col"] .search-form-body').append(component.$html);
      } else if (
        ["result_type_0", "result_type_1", "result_type_2", "result_type_3"].includes(field)
      ) {
        $('.search-form-layout[data-layout="result-type"] .search-form-body').append(
          component.$html,
        );
      } else if (
        ["bde", "fjse", "lxqj", "fzse", "textlen_range", "year", "zyjd", "ajtz"].includes(field)
      ) {
        $('.search-form-layout[data-layout="row"] .search-form-body').append(component.$html);
      }
      this.components.set(field, component);
    },

    emitterChange: useDebounce(function () {
      this.emitter.emit("change", this.getData());
    }, 1000),

    directEmitterChange() {
      this.emitter.emit("change", this.getData());
    },

    tagComponents: [], // { field, handleDelete, handleUpdate }[]
    // 渲染搜索标签
    renderTagItem(item, $wrapper, readonly = false) {
      const $label = $('<span class="search-box-item-label">');
      const $content = $('<span class="search-box-item-content">');
      const $close = $('<i class="search-box-item-close iconfont icon-close">');
      const $html = $(
        `<div class="search-box-item ${readonly || this.isGJJS ? "readonly" : ""}">`,
      ).append($label, $content, $close);

      const render = () => {
        const _value = item.value instanceof Array ? item.value : [item.value];
        let labelText = item.label ? `${item.label}：` : "";
        let contentText = _value.map((_) => (typeof _ === "string" ? _ : _.text)).join(",");

        switch (item.field) {
          case "all_law_text": {
            contentText = _value
              .map((_) => {
                let text = _.text;
                if (_.tiao) {
                  text += `第${_.tiao}条`;
                }
                if (_.kuan) {
                  text += `第${_.kuan}款`;
                }
                if (_.xiang) {
                  text += `第${_.xiang}项`;
                }
                return text;
              })
              .join(",");
            break;
          }
          case "dsr_tag": {
            contentText = _value
              .map((_) =>
                [getName(sideOptions, _.side), getName(typeOptions, _.type), _.text]
                  .filter(Boolean)
                  .join("|"),
              )
              .join(",");
            break;
          }
          case "result_type_0": {
            contentText = `一审|${_value.map((_) => _.text).join(",")}`;
            break;
          }
          case "result_type_1": {
            contentText = `二审|${_value.map((_) => _.text).join(",")}`;
            break;
          }
          case "result_type_2": {
            contentText = `再审|${_value.map((_) => _.text).join(",")}`;
            break;
          }
          case "result_type_3": {
            contentText = `执行|${_value.map((_) => _.text).join(",")}`;
            break;
          }
        }

        $label.text(labelText);
        $content
          .text(this.sliceText(contentText, 20 - $label.text().length))
          .attr("title", contentText);
      };

      render();

      const handleDelete = () => {
        const index = this.tagComponents.findIndex((_instance) => _instance === instance);
        if (~index) this.tagComponents.splice(index, 1);
        $html.remove();
      };

      const handleUpdate = (_item) => {
        item = _item;
        render();
      };

      const instance = { $html, field: item.field, handleDelete, handleUpdate };

      $close.on("click", () => {
        searchFormPattern.setData({ ...item, value: undefined }, { directEmitter: true });
      });

      !readonly && this.tagComponents.push(instance);

      $($wrapper).length && $($wrapper).append($html);

      return instance;
    },

    renderKeywordTagItem(item, $wrapper, readonly = false) {
      const options = (modelData || []).map((item) => ({ name: item.name, value: item.typeid }));

      // const $label = $('<span class="search-box-item-label">').toggleClass(
      //   "cursor-pointer",
      //   !readonly,
      // );
      const $label = $('<span class="search-box-item-label">');
      const $content = $('<span class="search-box-item-content">');
      // const $tag = $('<span class="search-box-item-tag">近</span>');
      const $close = $('<i class="search-box-item-close iconfont icon-close">');
      const $html = $(
        `<div class="search-box-item ${readonly || this.isGJJS ? "readonly" : ""}">`,
      ).append($label, $content, $close);

      const getValues = () => (item.value instanceof Array ? item.value : [item.value]);
      const handleDelete = () => {};
      const handleUpdate = () => {};
      const render = () => {
        const _value = getValues();
        // const labelText = `${getName(options, item.field)}<i class="iconfont icon-caret-down-small"></i>：`;
        const labelText = `${getName(options, item.field)}：`;
        const contentText = _value.join(" | ");

        $label.html(labelText);
        $content
          .text(this.sliceText(contentText, 20 - $label.text().length))
          .attr("title", contentText);
      };

      render();

      const instance = { $html, field: item.field, handleDelete, handleUpdate };

      // !readonly &&
      //   !this.isGJJS &&
      //   new DropDown({
      //     customClass: "keyword-custom-dropdown",
      //     $input: $label,
      //     $reference: $html,
      //     minWidth: "72px",
      //     maxWidth: "72px",
      //     data: options,
      //     value: item.field,
      //     slotItem: (item) => `<span style="font-size: 12px">${item.name}</span>`,
      //   }).emitter.on("change", (value) => {
      //     item.field = value;
      //     item.label = getName(options, value).replaceAll(" ", "");
      //     instance.field = value;
      //     render();
      //     this.directEmitterChange();
      //   });

      $close.on("click", () => {
        const index = this.tagComponents.findIndex((_instance) => _instance === instance);
        if (~index) this.tagComponents.splice(index, 1);

        const index2 = this.formData.findIndex((_item) => _item === item);
        if (~index2) this.formData.splice(index2, 1);

        $html.remove();

        if (this.tagComponents.length) {
          $("#searchButtonWrapper").show();
        } else {
          $("#searchButtonWrapper").hide();
        }

        this.directEmitterChange();
      });

      // $tag.on("click", async () => {
      //   const [k, ...v] = getValues();

      //   const words = await showSynonymDialog(k, v);
      //   item.value = [k, ...words];
      //   this.directEmitterChange();
      //   render();
      // });

      // // 近义词
      // !readonly &&
      //   !this.isGJJS &&
      //   createFetch("/Home/NearWord/isShow", {
      //     keyword: getValues()[0],
      //   }).then(({ is_show }) => {
      //     is_show && $close.before($tag);
      //   });

      !readonly && this.tagComponents.push(instance);
      $($wrapper).length && $($wrapper).append($html);

      return instance;
    },
  };

  function createFormItemLayout({ field, label, formControlElement }) {
    const useVip = isVipMap[field];
    const $formItem = $('<div class="search-form-item">');
    const $label = $('<div class="search-form-label">')
      .text(label || "")
      .toggleClass("use-vip", useVip);
    const $formControl = $('<div class="search-form-control">').append(formControlElement);

    if (field === "result_type") {
      $('.search-form-layout[data-layout="result-type"] > .search-form-label').toggleClass(
        "use-vip",
        useVip,
      );
    }

    $formItem.append($label);
    $formItem.append($formControl);

    $formControl[0].addEventListener(
      "click",
      (e) => {
        if (useVip && !isVipFlag) {
          e.stopPropagation();
          createPermissionsNumber(10, {
            tip: "此功能为会员功能，请升级会员",
            btn_text: "升级权限",
            hightlight: ["升级权限"],
            return_index: 0,
          });
        }
      },
      true,
    );

    if (["bde", "fjse", "lxqj", "fzse", "textlen_range", "year", "zyjd", "ajtz"].includes(field)) {
      $formControl[0].addEventListener(
        "mouseover",
        (e) => {
          if (useVip && !isVipFlag) {
            e.stopPropagation();
          }
        },
        true,
      );
    }
    return $formItem;
  }

  function createDropdownLable({ label }) {
    const $text = $("<span>").text(label);
    const $dorpdown = $('<i class="iconfont icon-xiala1 ml-4 cursor-pointer">');
    const $number = $('<span class="search-number ml-4">');
    const $label = $('<span class="search-dropdown-label">').append($text, $number, $dorpdown);

    return {
      $label,
      $number,
      $dorpdown,
      setName: (label) => $text.text(label),
      setNumber: (num) => $number.text(num || ""),
    };
  }

  function createSearchTag({ field, label, item }, slice = 0) {
    let text = item.text;
    if (field === "all_law_text") {
      if (item.tiao) {
        text += `第${item.tiao}条`;
      }
      if (item.kuan) {
        text += `第${item.kuan}款`;
      }
      if (item.xiang) {
        text += `第${item.xiang}项`;
      }
    }

    let sliceText = text;

    if (slice && slice < text.length - 1) {
      sliceText = text.slice(0, slice) + "…";
    }

    const $del = $('<i class="iconfont icon-close1">');
    const $tag = $(`<span class="input-tag-item" title="${text}">`).append(
      $("<span>").text(sliceText),
      $del,
    );
    $del.on("click", (e) => {
      const allValues = searchFormPattern.getData(field)?.value || [];
      searchFormPattern.setData({
        field,
        label,
        value: allValues.filter((v) => v.id !== item.id),
      });
      $tag.remove();
      e.stopPropagation();
    });

    return $tag;
  }

  function createTagDropdownProxy({ $input, maxLength = 2, field, label }) {
    const instance = new DropDownProxy({
      maxWidth: "364px",
      trigger: "hover",
      $input,
      placement: "top",
      selfOnly: true,
    });

    const $html = $('<div class="search-tag-dropdown-content">');

    instance.$html.append($html);

    instance.emitter.on("toggleShow", (isShow) => {
      if (!isShow) return;
      const allValues = searchFormPattern.getData(field)?.value || [];
      const values = allValues.slice(maxLength);
      $html.empty().append(values.map((item) => createSearchTag({ field, label, item })));
    });

    return instance;
  }

  function createSearchTagInput({
    field,
    label,
    placeholder = "",
    maxLength = 2,
    slice = 4,
    clearable = true,
    useInput = false,
  }) {
    const $inputBox = $('<div class="search-input-box">');
    const $number = $('<span class="search-input-number">');
    const $clear = $('<i class="search-input-clear iconfont icon-close-circle-filled">');
    const $content = $('<span class="search-input-content">');
    const $input = $(`<input class="input"/>`);

    createTagDropdownProxy({
      $input: $number,
      maxLength,
      field,
      label,
    });

    function setValue(allValues) {
      const values = maxLength ? allValues.slice(0, maxLength) : allValues;
      const _slice = values.length === 1 ? 13 : slice;
      $content
        .empty()
        .append(values.map((item) => createSearchTag({ field, label, item }, _slice)));
      $number.text(
        maxLength && allValues.length > maxLength ? `+${allValues.length - maxLength}` : "",
      );
      $clear[allValues.length ? "addClass" : "removeClass"]("hover-show");
    }

    $clear.on("click", (e) => {
      e.stopPropagation();
      $input.val("").trigger("input");
      searchFormPattern.setData({ field, label, value: [] });
    });

    useInput &&
      $input
        .on("focus", () => {
          if ($content.children().length === 1) {
            $inputBox.addClass("focus-single");
          } else if ($content.children().length > 1) {
            $inputBox.addClass("focus");
          }
        })
        .on("blur", () => {
          $inputBox.removeClass("focus focus-single");
        });

    $inputBox.append($content, $number);

    if (useInput) {
      $inputBox.append($input.attr("placeholder", placeholder));
    } else {
      $content.attr("placeholder", placeholder);
    }

    if (clearable) {
      $inputBox.append($clear);
      $inputBox.css("padding-right", "28px");
    }

    return {
      $inputBox,
      $input,
      setValue,
    };
  }

  function createSearchKeywordDropdownProxyContainer({ type, multiple = false }) {
    let values = []; // 选中的值 { id, text }[]
    let keyword = "";
    const emitter = useEmitter();
    const namespace = "search-autocomplete-dropdown";
    const $rest = $('<div class="button-box">重置</div>');
    const $more = $('<div class="button-box primary">查看更多</div>');
    const $list = $(`<ul class="${namespace}-list">`);
    const $empty = $(`<li class="${namespace}-empty">暂无数据</li>`);
    const $footer = $(`<div class="${namespace}-footer">`).append($rest, $more);

    const showEmpty = () => {
      $list.empty().append($empty);
      moreState(false);
      restState(values.length);
    };

    const moreState = (isShow) => {
      $more[isShow ? "show" : "hide"]();
      if ($more.css("display") === "none" && $rest.css("display") === "none") {
        $footer.hide();
      } else {
        $footer.css({ display: "flex" });
      }
    };

    const restState = (isShow) => {
      $rest[isShow ? "show" : "hide"]();
      if ($more.css("display") === "none" && $rest.css("display") === "none") {
        $footer.hide();
      } else {
        $footer.css({ display: "flex" });
      }
    };

    const render = (data = []) => {
      $list.empty();

      if (data.length === 0) return showEmpty();

      data.forEach(({ word: text, word_id: id }) => {
        const isDisabled = !!values.find((item) => item.id === id);
        const $item = $(
          `<li data-id="${id}" class="${namespace}-item ${isDisabled ? "disabled" : ""}" title="${text}"><span>${type}</span>${text.replace(new RegExp(keyword, "gi"), `<i>${keyword}</i>`)}</li>`,
        );
        $item.on("click", () => {
          if ($item.hasClass("disabled")) return;
          multiple ? values.push({ id, text }) : (values = [{ id, text }]);
          emitChange();
        });
        $list.append($item);
      });
    };

    const request = async (str, isMore = false) => {
      keyword = str;
      const params = {
        con: keyword,
        type,
        size: isMore ? 40 : 10,
        searchTime: +new Date(),
        search_type: "text",
      };

      if (!keyword) return showEmpty();

      const info = await createFetch("/Home/search/getAssoWord", params);
      render(info?.[0]?.data);
      moreState(!isMore && info?.[0]?.data.length >= 10);
    };

    const setValue = function (value) {
      values = value instanceof Array ? value : [];
      restState(values.length);
      $list.find(`.${namespace}-item`).each((_, el) => {
        const id = $(el).data("id");
        const isDisabled = !!values.find((item) => item.id == id);
        $(el).toggleClass("disabled", isDisabled);
      });
    };

    const emitChange = () => {
      emitter.emit("change", multiple ? values : values[0]);
      setValue(values);
    };

    $rest.on("click", () => {
      values = [];
      emitChange();
    });
    $more.on("click", () => request(keyword, true));

    return {
      emitter,
      $footer,
      $list,
      request: useDebounce(request, 300),
      setValue,
    };
  }

  function createAutocompleteDropdownProxy({ field, label, $input, type }) {
    const namespace = "search-autocomplete-dropdown";
    const {
      $list,
      $footer,
      request,
      setValue: setListValue,
      emitter: listEmitter,
    } = createSearchKeywordDropdownProxyContainer({ type, multiple: true });

    const $html = $(`<div class="${namespace}">`).append($list, $footer);

    const dropdownInstance = new DropDownProxy({ $input, trigger: "custom", minWidth: "inherit" });

    listEmitter.on("change", (values) => {
      searchFormPattern.setData({ field, label, value: values });
      dropdownInstance.dropdownHide();
    });

    dropdownInstance.$html.append($html);

    request();

    return {
      dropdownInstance,
      listEmitter,
      request,
      setValue(allValues) {
        setListValue(allValues);
      },
    };
  }

  function createAmountDropDwonProxy({
    field,
    label,
    $input,
    $reference,
    options = [],
    ...dropDownProps
  }) {
    const $checkboxGroup = $('<div class="checkbox-group">');
    const $footer = $('<div class="multiple-dropdown-footer">');
    const $rest = $('<div class="button-box"><i class="iconfont icon-refresh"></i>重置</div>');

    const dropdownInstance = new DropDownProxy({
      $input,
      $reference,
      minWidth: "150px",
      ...dropDownProps,
    });

    const getText = (start, end) => {
      if (start && end) {
        return `${start}-${end}万`;
      }
      if (start) {
        return `${start}万以上`;
      }
      if (end) {
        return `${end}万以下`;
      }
      return "";
    };

    const checkboxInstances = options.map(({ name, value, start, end }) => {
      const isCustom = value === "6";

      const $start = $('<input type="text" autocomplete="off" placeholder="最低">');
      const $end = $('<input type="text" autocomplete="off" placeholder="最高">');
      const $confirm = $('<div class="button-box primary plan disabled">确定</div>');
      const $labelSlot = $('<div class="flex items-center" style="gap: 10px">')
        .append(
          $('<div class="input-picker-wrapper" style="width: 230px">').append(
            $('<div class="input-slot" suffix="万">').append($start),
            "-",
            $('<div class="input-slot" suffix="万">').append($end),
          ),
          $confirm,
        )
        .on("click", (e) => e.stopPropagation());

      const instance = new Checkbox({
        label: name,
        value: value,
        container: $checkboxGroup,
        readonly: isCustom,
        labelSlot: isCustom ? $labelSlot : undefined,
      });

      instance.emitter.on("change", (checked) => {
        if (!checked && isCustom) instance.setReadonly(true);

        searchFormPattern.setData({
          field,
          label,
          value: checked
            ? {
                text: getText(start, end),
                id: value,
                start,
                end,
              }
            : null,
        });
      });

      $confirm.on("click", (e) => {
        e.stopPropagation();
        if ($confirm.hasClass("disabled")) return;

        if ($start.val() > $end.val()) {
          $.message.warning(`请正确输入${label}范围金额`);
          return;
        }

        instance.setReadonly(false);
        searchFormPattern.setData({
          field,
          label,
          value: {
            text: getText($start.val(), $end.val()),
            start: $start.val(),
            end: $end.val(),
            id: value,
          },
        });
      });

      $start.on("input", () => {
        if (!/^\d+(\.\d+)?$/.test($start.val())) {
          $start.val($start.val().replace(/[^0-9\.]/g, ""));
        }
        $confirm.toggleClass("disabled", !$start.val() && !$end.val());
        !$start.val() && !$end.val() && searchFormPattern.setData({ field, label, value: null });
      });

      $end.on("input", () => {
        if (!/^\d+(\.\d+)?$/.test($end.val())) {
          $end.val($end.val().replace(/[^0-9\.]/g, ""));
        }
        $confirm.toggleClass("disabled", !$start.val() && !$end.val());
        !$start.val() && !$end.val() && searchFormPattern.setData({ field, label, value: null });
      });

      return {
        instance,
        setValue: (_) => {
          const { id, start, end } = _ || {};
          const isChecked = id === value;
          instance.setValue(isChecked);
          if (value === "6") {
            instance.setReadonly(!isChecked);
            $start.val(isChecked ? start : "");
            $end.val(isChecked ? end : "");
            $confirm.toggleClass("disabled", !$start.val() && !$end.val());
          }
        },
      };
    });

    dropdownInstance.$html.append(
      $('<div class="multiple-dropdown-content">').append(
        $('<div class="multiple-dropdown-body">').append($checkboxGroup),
        $footer.append($rest),
      ),
    );

    $rest.on("click", () => searchFormPattern.setData({ field, label, value: null }));

    return {
      setValue: (value) => checkboxInstances.forEach(({ setValue }) => setValue(value)),
    };
  }

  async function showSaveTemplateDialog() {
    const $inputWrapper = $('<div class="search-input-box" style="padding-right: 28px;">');
    const $clear = $('<i class="search-input-clear iconfont icon-close-circle-filled">');
    const $input = $(
      '<input class="input" maxlength="15" type="text" autocomplete="off" placeholder="请输入模板名称">',
    );
    const $count = $('<span class="search-input-count">0/15</span>');

    $clear.on("click", () => $input.val("").trigger("input"));
    $input.on("input", () => {
      $clear.toggleClass("hover-show", !!$input.val());
      $count.text(`${$input.val().length}/15`);
    });

    const formData = searchFormPattern.getDataFlat();

    const $tags = formData
      .sort((a, b) => {
        if (keywordField.includes(a.field) && keywordField.includes(b.field)) return 0;
        if (keywordField.includes(a.field)) return -1;
        if (keywordField.includes(b.field)) return 1;
        return 0;
      })
      .map((item) => {
        let $html;
        if (keywordField.includes(item.field)) {
          $html = searchFormPattern.renderKeywordTagItem(item, undefined, true).$html;
        } else {
          $html = searchFormPattern.renderTagItem(item, undefined, true).$html;
        }
        return $html;
      });

    await showDialog({
      showLogo: true,
      title: "保存模版",
      okText: "确认",
      html: $('<div class="save-template-dialog">').append(
        $("<div>").append(
          "<label>模版名称：</label>",
          $inputWrapper.append($input, $clear),
          $count,
        ),
        $("<div>").append(
          "<label>已选条件：</label>",
          $('<div class="save-template-tags">').append($tags),
        ),
      ),
      width: 500,
      showCancelButton: false,
      beforeOk: async () => {
        if (!$input.val().trim()) {
          $.message.warning("请输入模版名称");
          return false;
        }
        const res = await createFetch(
          "/Home/Focus/doFocus",
          {
            focus_name: $input.val().trim(),
            // keyword: "案例搜索：纠纷 , 法院|#|gggg|#|ddd|#|司法机关|#|法庭 , 合同|#|fff|#|协议 , 法院层级：中级法院 , 专门法院：海事法院 , 专门法院：铁路运输法院 , 基本案情：分割知识产权的收益 , 基本案情：知识产权出资",
            keyword: `案例搜索：` + SearchListParams.getParamKeyword(formData),
            search_uuid: getQueryString("search_uuid"),
          },
          undefined,
          true,
        );
        if (res != 0) {
          $.message.error(res?.msg || "保存失败");
          return false;
        } else {
          $.message.success("保存成功");
          $("#templateDropdown").show();
          return true;
        }
      },
    });
  }

  async function showSynonymDialog(keyword, value) {
    const $inputWrapper = $('<div class="search-input-box" style="padding-right: 28px;">');
    const $clear = $('<i class="search-input-clear iconfont icon-close-circle-filled">');
    const $input = $(
      '<input class="input" type="text" autocomplete="off" placeholder="添加自定义近义词">',
    );
    const $add = $('<div class="button-box small primary plan">添加</div>');
    const $header = $('<div class="synonym-header">').append(
      "近义词：",
      $inputWrapper.append($input, $clear),
      $add,
    );

    const selectAllInstance = new Checkbox({ label: "全选" });
    const checkboxGroupInstance = new CheckboxGroup({ data: [], value });

    const arr = await createFetch("/Home/NearWord/wordList", { word: keyword }, undefined, true);
    const options = (arr || []).map(({ word }) => ({ name: word, value: word }));
    checkboxGroupInstance.updateData(options);
    selectAllInstance.setValue(options.length === value.length);

    $clear.on("click", () => $input.val("").trigger("input"));
    $input.on("input", () => $clear.toggleClass("hover-show", !!$input.val()));
    $add.on("click", async () => {
      const val = $input.val().trim();
      if (!val) return $.message.warning("清勿添加空白词组");

      await createFetch("/Home/NearWord/addUserNearWord", { word: keyword, nearword: val });
      checkboxGroupInstance.updateData([...options, { name: val, value: val }]);
      checkboxGroupInstance.setValue([...checkboxGroupInstance.getValue(), val]);
      $input.val("");
    });

    checkboxGroupInstance.emitter.on("change", (value) => {
      const data = checkboxGroupInstance.options.data;
      selectAllInstance.setValue(value.length === data.length);
    });

    selectAllInstance.emitter.on("change", (isChecked) => {
      const data = checkboxGroupInstance.options.data;
      checkboxGroupInstance.setValue(isChecked ? data.map(({ value }) => value) : []);
    });

    await showDialog({
      showLogo: true,
      title: "近义词",
      html: $('<div class="synonym-dialog">').append($header, checkboxGroupInstance.$html),
      width: 500,
      height: 240,
      okText: "确认",
      footerActionsSlot: selectAllInstance.$html,
    });

    return checkboxGroupInstance.getValue();
  }

  async function showTreeTransferDialog({ label, field, data }) {
    const transferInstance = new TreeTransfer({
      data,
      value: searchFormPattern.getData(field)?.value || [],
    });

    await showDialog({
      showLogo: true,
      title: label,
      html: transferInstance.$html,
      width: 822,
      okText: "确认",
    });

    const value = transferInstance.getValue();

    searchFormPattern.setData({
      field,
      label,
      value: value.map(({ id, path, name }) => ({ id, path, text: name })),
    });
  }

  async function showAllLawTextDialog() {
    const values = searchFormPattern.getData("all_law_text")?.value || [];
    const math = searchFormPattern.getData("all_law_text")?.condition || "|";
    const $html = $('<div class="all-law-text-ul">');
    const radioGroupInstance = new RadioGroup({
      data: [
        { name: "或", value: "|" },
        { name: "且", value: "&" },
        { name: "且不含", value: "!" },
      ],
      value: math,
    });

    const addItem = (data, isFirst) => {
      const { id = "", text = "", tiao = "", kuan = "", xiang = "" } = data || {};

      const $item = $(`<div class="all-law-text-li">`);
      const $add = $('<div class="icon"><i class="iconfont icon-add"></i></div>');
      const $del = $('<div class="icon"><i class="iconfont icon-remove"></i></div>');
      const $input = $(
        `<input name="text" autocomplete="off" type="text" placeholder="请输入引用法条，支持模糊查找">`,
      );
      const $tiao = $('<input name="tiao" autocomplete="off" type="text">').on("input", () => {
        if (!/^\d+$/.test($tiao.val())) {
          $tiao.val($tiao.val().replace(/\D/g, ""));
        }
      });
      const $kuan = $('<input name="kuan" autocomplete="off" type="text">').on("input", () => {
        if (!/^\d+$/.test($kuan.val())) {
          $kuan.val($kuan.val().replace(/\D/g, ""));
        }
      });
      const $xiang = $('<input name="xiang" autocomplete="off" type="text">').on("input", () => {
        if (!/^\d+$/.test($xiang.val())) {
          $xiang.val($xiang.val().replace(/\D/g, ""));
        }
      });

      $input.val(text).data("id", id);
      $tiao.val(tiao);
      $kuan.val(kuan);
      $xiang.val(xiang);

      const $inputWrapper = $(`<div class="all-law-text-input">`).append(
        $input,
        $('<div class="all-law-text-item">').append(
          "第",
          $tiao,
          "条，第",
          $kuan,
          "款，第",
          $xiang,
          "项",
        ),
      );

      const { emitter, $footer, $list, request, setValue } =
        createSearchKeywordDropdownProxyContainer({
          type: "法律法规",
        });

      setValue(data);
      request();

      const dropdownInstance = new DropDownProxy({
        $input: $input,
        $reference: $inputWrapper,
        trigger: "custom",
        minWidth: "inherit",
        maxWidth: "inherit",
        placement: "bottom-start",
      });

      dropdownInstance.$html.append(
        $('<div class="search-autocomplete-dropdown" style="width: auto;">').append($list, $footer),
      );

      $input.on("input", () => {
        const val = $input.val();
        $input.data("id", "");
        setValue([]);
        request(val);
        dropdownInstance.toggleShow(!val);
      });

      // $input.on("focus", () => {
      //   const val = $input.val();
      //   if (!val) return;
      //   request(val);
      //   dropdownInstance.dropdownShow();
      // });

      $input.on("blur", () => {
        if (!$input.data("id")) {
          $input.val("");
          setValue([]);
        }
      });

      $add.on("click", () => addItem());

      $del.on("click", () => $item.remove());

      emitter.on("change", (item) => {
        // { id: text }
        if (item) {
          $input.data("id", item.id);
          $input.val(item.text);
        } else {
          $input.data("id", "");
          $input.val("");
        }

        dropdownInstance.dropdownHide();
      });

      $html.append($item.append($inputWrapper, isFirst ? $add : $del));
    };

    if (values.length) {
      values.forEach((item, index) => addItem(item, index === 0));
    } else {
      addItem(undefined, true);
    }

    await showDialog({
      showLogo: true,
      title: "引用法条",
      html: $html,
      width: 560,
      okText: "确认",
      cancelText: "重置",
      footerActionsSlot: $('<div class="flex items-center">').append(
        "条件关系：",
        radioGroupInstance.$html,
      ),
      beforeCancel: () => {
        $html.empty();
        addItem(undefined, true);
        return false;
      },
    });

    const resultValues = [];

    $html.find(".all-law-text-li").each((_, el) => {
      const $input = $(el).find("input[name=text]");
      const $tiao = $(el).find("input[name=tiao]");
      const $kuan = $(el).find("input[name=kuan]");
      const $xiang = $(el).find("input[name=xiang]");
      const id = $input.data("id");

      if (!id) return;
      resultValues.push({
        id,
        text: $input.val(),
        tiao: $tiao.val(),
        kuan: $kuan.val(),
        xiang: $xiang.val(),
      });
    });

    searchFormPattern.setData({
      field: "all_law_text",
      label: "引用法条",
      value: resultValues,
      condition: radioGroupInstance.getValue(),
    });
  }

  function dsrTagDropDown($input) {
    const wrapDeopdownInstance = new DropDownProxy({
      $input,
      minWidth: "560px",
      maxWidth: "560px",
    });

    const $wrap = $('<div class="dialog-container dsr-tag-dropdown">');

    $wrap.append([
      `<div class="dialog-header">
        <h3 class="dialog-title">当事人</h3>
        <div class="dialog-header-actions-slot"></div>
        <div class="dialog-header-logo">
          <img src="/static/Public/images/new_home/41.png" alt="Logo" />
        </div>
        <i class="iconfont icon-close1 dialog-close"></i>
      </div>`,
      `<div class="dialog-body">
        <div class="dialog-content"></div>
      </div>`,
      `<div class="dialog-footer">
        <div class="dialog-footer-actions-slot"></div>
        <div class="dialog-footer-buttons">
          <button class="dialog-btn dialog-btn-cancel">重置</button>
          <button class="dialog-btn dialog-btn-ok">确认</button>
        </div>
      </div>`,
    ]);

    wrapDeopdownInstance.$html.append($wrap);

    const $html = $('<div class="dsr-tag-ul">');
    const radioGroupInstance = new RadioGroup({
      data: [
        { name: "或", value: "|" },
        { name: "且", value: "&" },
        { name: "且不含", value: "!" },
      ],
      value: "|",
    });

    const addItem = (data, isFirst) => {
      const { id = "", text = "", side = "", type = "" } = data || {};

      const $item = $(`<div class="dsr-tag-li">`);
      const $add = $('<div class="icon"><i class="iconfont icon-add"></i></div>');
      const $del = $('<div class="icon"><i class="iconfont icon-remove"></i></div>');
      const $input = $(`<input name="text" autocomplete="off" type="text" placeholder="请输入">`);

      const { $label: $sideLabel, setName: setSideName } = createDropdownLable({
        label: "攻/守方",
      });
      const { $label: $typeLabel, setName: setTypeName } = createDropdownLable({
        label: "机构/个人",
      });

      new DropDown({
        $input: $sideLabel,
        value: side,
        data: sideOptions,
        minWidth: "inherit",
        parentInstance: wrapDeopdownInstance,
      }).emitter.on("change", (value) => {
        $sideLabel.data("value", value);
        setSideName(getName(sideOptions, value));
      });

      new DropDown({
        $input: $typeLabel,
        value: type,
        data: typeOptions,
        minWidth: "inherit",
        parentInstance: wrapDeopdownInstance,
      }).emitter.on("change", (value) => {
        $typeLabel.data("value", value);
        setTypeName(getName(typeOptions, value));
      });

      $input.val(text).data("id", id);
      $sideLabel.data("value", side).addClass("sideLabel");
      $typeLabel.data("value", type).addClass("typeLabel");
      side && setSideName(getName(sideOptions, side));
      type && setTypeName(getName(typeOptions, type));

      const $inputWrapper = $(`<div class="dsr-tag-input">`).append($sideLabel, $typeLabel, $input);

      const { emitter, $footer, $list, request, setValue } =
        createSearchKeywordDropdownProxyContainer({
          type: "机构",
        });

      setValue(data);
      request();

      const dropdownInstance = new DropDownProxy({
        $input: $input,
        $reference: $inputWrapper,
        trigger: "custom",
        minWidth: "inherit",
        maxWidth: "inherit",
        placement: "bottom-start",
        parentInstance: wrapDeopdownInstance,
      });

      dropdownInstance.$html.append(
        $('<div class="search-autocomplete-dropdown" style="width: auto">').append($list, $footer),
      );

      $input.on("input", () => {
        const val = $input.val();
        $input.data("id", "");

        if ($typeLabel.data("value") !== "个人") {
          setValue([]);
          request(val);
          dropdownInstance.toggleShow(!val);
        }
      });

      // $input.on("focus", () => {
      //   const val = $input.val();
      //   if (!val) return;
      //   request(val);
      //   dropdownInstance.dropdownShow();
      // });

      // $input.on("blur", () => {
      //   if (!$input.data("id")) {
      //     $input.val("");
      //     setValue([]);
      //   }
      // });

      $add.on("click", () => addItem());

      $del.on("click", () => $item.remove());

      emitter.on("change", (item) => {
        // { id: text }
        if (item) {
          $input.data("id", item.id);
          $input.val(item.text);
        } else {
          $input.data("id", "");
          $input.val("");
        }

        dropdownInstance.dropdownHide();
      });

      $html.append($item.append($inputWrapper, isFirst ? $add : $del));
    };

    const setSearchFormPattern = () => {
      const resultValues = [];

      $html.find(".dsr-tag-li").each((_, el) => {
        const $input = $(el).find("input[name=text]");
        const $sideLabel = $(el).find(".sideLabel");
        const $typeLabel = $(el).find(".typeLabel");
        const id = $input.data("id");
        const text = $input.val();
        const side = $sideLabel.data("value");
        const type = $typeLabel.data("value");

        if (!side && !type && !text) return;

        resultValues.push({
          id,
          text,
          side: side || "all",
          type: type || "不限",
        });
      });

      searchFormPattern.setData({
        field: "dsr_tag",
        label: "当事人",
        value: resultValues,
        condition: radioGroupInstance.getValue(),
      });
    };

    $wrap.find(".dialog-content").html($html);
    $wrap
      .find(".dialog-footer-actions-slot")
      .html($('<div class="flex items-center">').append("条件关系：", radioGroupInstance.$html));

    $wrap.find(".dialog-btn-cancel").on("click", () => {
      $html.empty();
      addItem(undefined, true);
      setSearchFormPattern();
      wrapDeopdownInstance.dropdownHide();
    });

    $wrap.find(".dialog-btn-ok").on("click", () => {
      setSearchFormPattern();
      wrapDeopdownInstance.dropdownHide();
    });

    $wrap.find(".dialog-close").on("click", () => {
      wrapDeopdownInstance.dropdownHide();
    });

    wrapDeopdownInstance.emitter.on("toggleShow", (isShow) => {
      if (!isShow) {
        $html.empty();
      } else {
        const values = searchFormPattern.getData("dsr_tag")?.value || [];
        const math = searchFormPattern.getData("dsr_tag")?.condition || "|";

        radioGroupInstance.setValue(math);

        if (values.length) {
          values.forEach((item, index) => addItem(item, index === 0));
        } else {
          addItem(undefined, true);
        }
      }
    });

    return {
      instance: wrapDeopdownInstance,
    };
  }

  // 创建【案由】表单组件
  function createReasonFormComponent() {
    const label = "案由";
    const field = "reason";
    const options = reasonData.map(({ id, name }) => ({ value: id, name }));

    const checkboxInstances = options.map((item) => {
      const { $label: $labelSlot, $dorpdown } = createDropdownLable({ label: item.name });

      const instance = new Checkbox({
        value: item.value,
        label: item.name,
        labelSlot: $labelSlot,
      });

      $dorpdown.on("click", (e) => {
        e.stopPropagation();
        showTreeTransferDialog({ label, field, data: reasonData });
      });

      instance.emitter.on("change", (checked) => {
        const allValues = searchFormPattern.getData(field)?.value || [];
        const resValues = [];

        // 移除选项
        allValues.forEach(
          ({ id, path, text }) => !path.includes(item.value) && resValues.push({ id, path, text }),
        );
        // 添加新选中的项
        checked && resValues.push({ id: item.value, text: item.name, path: [item.value] });

        searchFormPattern.setData({ field, label, value: resValues });
      });
      return instance;
    });

    function setValue({ value = [] }) {
      const _values = value.map((item) => item.path[0]);

      checkboxInstances.forEach((instance) => {
        instance.setValue(_values.includes(instance.value));
      });
    }

    return {
      $html: createFormItemLayout({
        field,
        label,
        formControlElement: checkboxInstances.map((inst) => inst.$html),
      }),
      setValue,
    };
  }

  // 创建【文书性质】表单组件
  function createJudgementFormComponent() {
    const label = "文书性质";
    const field = "judgement";
    const options = [
      { value: "1", name: "判决" },
      { value: "2", name: "裁定" },
      { value: "3", name: "通知" },
      { value: "4", name: "决定" },
      { value: "5", name: "调解" },
      { value: "7", name: "开庭公告" },
      { value: "6", name: "其他" },
    ];

    const checkboxGroupInstance = new CheckboxGroup({ data: options });

    checkboxGroupInstance.emitter.on("change", (value) => {
      searchFormPattern.setData({
        field,
        label,
        value: value.map((item) => ({
          id: item,
          text: options.find((d) => d.value === item).name,
        })),
      });
    });

    function setValue({ value = [] }) {
      const _values = value.map((item) => item.id);
      checkboxGroupInstance.setValue(_values);
    }

    return {
      $html: createFormItemLayout({
        field,
        label,
        formControlElement: checkboxGroupInstance.$html,
      }),
      setValue,
    };
  }

  // 创建【文书类型】表单组件
  function createCaseLevelFormComponent() {
    const label = "文书类型";
    const field = "case_level";
    const options = [
      { value: "23", name: "参考案例" },
      { value: "10", name: "指导性案例" },
      { value: "3", name: "典型案例" },
      { value: "9", name: "检察案例" },
      { value: "14", name: "优秀文书" },
      { value: "7", name: "公报案例" },
      /*{ value: 11, name: '刑事审判参考' },*/
      // { value: "1", name: "普通案例" },
      { value: "24", name: "入库案例" },
    ];
    const optionsKeys = options.map((item) => item.value);

    const authorityCheckboxInstance = new Checkbox({ label: "权威案例" });
    const ordinaryCheckboxInstance = new Checkbox({ label: "普通案例" });

    const checkboxGroupInstance = new CheckboxGroup({ data: options });

    const setSearchFormValue = () => {
      const value = checkboxGroupInstance.getValue().map((item) => ({
        id: item,
        text: options.find((d) => d.value === item).name,
      }));
      if (ordinaryCheckboxInstance.getValue()) {
        value.push({ id: "1", text: "普通案例" });
      }

      searchFormPattern.setData({ field, label, value });
    };

    checkboxGroupInstance.emitter.on("change", () => {
      setSearchFormValue();
    });

    authorityCheckboxInstance.emitter.on("change", (isChecked) => {
      const value = isChecked ? optionsKeys : [];
      checkboxGroupInstance.setValue(value);
      setSearchFormValue();
    });

    ordinaryCheckboxInstance.emitter.on("change", () => {
      setSearchFormValue();
    });

    function setValue({ value = [] }) {
      const _values = [];
      value.forEach(({ id }) => {
        if (optionsKeys.includes(id)) {
          _values.push(id);
        }
      });
      checkboxGroupInstance.setValue(_values);
      authorityCheckboxInstance.setValue(_values.length);
      ordinaryCheckboxInstance.setValue(value.some(({ id }) => id == "1"));
    }
    return {
      $html: createFormItemLayout({
        field,
        label,
        formControlElement: [
          $('<div class="group-box" style="margin-bottom: 4px">').append(
            authorityCheckboxInstance.$html,
            checkboxGroupInstance.$html,
          ),
          $('<div class="group-box">').append(ordinaryCheckboxInstance.$html),
        ],
      }),
      setValue,
    };
  }

  // 创建【审判年限】表单组件
  function createCprqFormComponent() {
    const label = "审判年限";
    const field = "cprq";
    const options = [
      { value: "5", name: "近5年" },
      { value: "3", name: "近3年" },
      { value: "2", name: "近2年" },
      { value: "1", name: "近1年" },
      { value: "4", name: "自定义日期" },
    ];

    const $start = $('<input type="text" readonly placeholder="开始日期">');
    const $end = $('<input type="text" autocomplete="off" readonly placeholder="结束日期">');
    const $inputPicker = $('<div class="input-picker-wrapper">')
      .css({ marginLeft: "18px", width: "263px" })
      .append($start, " ~ ", $end);

    const handleDateChange = ($target) => {
      const start = $start.val();
      const end = $end.val();

      if (start && end) {
        if (new Date(start) > new Date(end)) {
          $.message.warning("开始日期不能晚于结束日期");
          $target.val("");
          return;
        }

        searchFormPattern.setData({
          field,
          label,
          value: { id: "4", text: `${start} ~ ${end}`, start, end },
        });
        return
      }

      if (radioGroupInstance.getValue() != "4") {
        if (new Date(start) > new Date(end)) {
          $.message.warning("开始日期不能晚于结束日期");
          $target.val("");
        }
        return;
      }
      if (!start || !end) {
        searchFormPattern.setData({ field, label, value: undefined });
        return;
      }

      if (new Date(start) > new Date(end)) {
        $.message.warning("开始日期不能晚于结束日期");
        $target.val("");
        searchFormPattern.setData({ field, label, value: undefined });
        return;
      }

      searchFormPattern.setData({
        field,
        label,
        value: { id: "4", text: `${start} ~ ${end}`, start, end },
      });
    };

    laydate.render({
      elem: $start[0],
      trigger: "click",
      max: createDateHtml(),
      done: () => setTimeout(() => handleDateChange($start)),
    });

    laydate.render({
      elem: $end[0],
      trigger: "click",
      max: createDateHtml(),
      done: () => setTimeout(() => handleDateChange($end)),
    });

    const radioGroupInstance = new RadioGroup({ data: options, cancelSelect: true });

    radioGroupInstance.emitter.on("change", (value) => {
      if (!value) {
        searchFormPattern.getData("cprq") &&
          searchFormPattern.setData({ field, label, value: undefined });
        return;
      }

      let start, end;
      switch (value) {
        case "5":
          start = createDateHtml(new Date().setFullYear(new Date().getFullYear() - 5));
          end = createDateHtml();
          break;
        case "3":
          start = createDateHtml(new Date().setFullYear(new Date().getFullYear() - 3));
          end = createDateHtml();
          break;
        case "2":
          start = createDateHtml(new Date().setFullYear(new Date().getFullYear() - 2));
          end = createDateHtml();
          break;
        case "1":
          start = createDateHtml(new Date().setFullYear(new Date().getFullYear() - 1));
          end = createDateHtml();
          break;
        default:
          start = $start.val();
          end = $end.val();
      }

      if (!start || !end) return;

      // $start.val(start);
      // $end.val(end);

      searchFormPattern.setData({
        field,
        label,
        value: { id: value, text: `${start} ~ ${end}`, start, end },
      });
    });

    function setValue({ value }) {
      if (radioGroupInstance.getValue() === "4" && !value && (!$start.val() || !$end.val())) return;

      radioGroupInstance.setValue(value?.id);

      if (value?.id === "4") {
        $start.val(value?.start || "");
        $end.val(value?.end || "");
      } else {
        $start.val("");
        $end.val("");
      }
    }

    return {
      $html: createFormItemLayout({
        field,
        label,
        formControlElement: $('<div class="flex items-center">').append(
          radioGroupInstance.$html,
          $inputPicker,
        ),
      }),
      setValue,
    };
  }

  // 创建【审理程序】表单组件
  function createRoundFormComponent() {
    const label = "审理程序";
    const field = "round";
    const checkboxGroupInstance = new CheckboxGroup({ data: roundOptions });

    checkboxGroupInstance.emitter.on("change", (value) => {
      searchFormPattern.setData({
        field,
        label,
        value: value.map((item) => ({
          id: item,
          text: roundOptions.find((d) => d.value === item).name,
        })),
      });
    });

    function setValue({ value = [] }) {
      const _values = value.map((item) => item.id);
      checkboxGroupInstance.setValue(_values);
    }

    return {
      $html: createFormItemLayout({
        field,
        label,
        formControlElement: checkboxGroupInstance.$html,
      }),
      setValue,
    };
  }

  // 创建【法院级别】表单组件
  function createCourtLevelFormComponent() {
    const label = "法院级别";
    const field = "court_level";
    const options = [
      { value: "4", name: "最高法院" },
      { value: "3", name: "高级法院" },
      { value: "2", name: "中级法院" },
      { value: "1", name: "基层法院" },
    ];

    const checkboxGroupInstance = new CheckboxGroup({ data: options });

    checkboxGroupInstance.emitter.on("change", (value) => {
      searchFormPattern.setData({
        field,
        label,
        value: value.map((item) => ({
          id: item,
          text: options.find((d) => d.value === item).name,
        })),
      });
    });

    function setValue({ value = [] }) {
      const _values = value.map((item) => item.id);
      checkboxGroupInstance.setValue(_values);
    }

    return {
      $html: createFormItemLayout({
        field,
        label,
        formControlElement: checkboxGroupInstance.$html,
      }),
      setValue,
    };
  }

  // 创建【专门法院】表单组件
  function createSpecialFormComponent() {
    const label = "专门法院";
    const field = "special";

    const checkboxInstances = specialData.map(({ id, name, children }) => {
      const { $label: $labelSlot, $dorpdown, setNumber } = createDropdownLable({ label: name });

      $dorpdown.on("click", (e) => {
        e.stopPropagation();
        showTreeTransferDialog({ label, field, data: specialData });
      });

      const instance = new Checkbox({
        value: id,
        label: name,
        labelSlot: $labelSlot,
      });

      const setSearchFormPattern = (values) => {
        // [id, id, ...]
        const allValues = searchFormPattern.getData(field)?.value || [];
        const resValues = [];

        // 移除选项
        allValues.forEach((item) => !item.path.includes(id) && resValues.push(item));

        if ((values.length === 1 && values[0] === id) || values.length >= children.length) {
          resValues.push({ id, text: name, path: [id] });
        } else {
          resValues.push(
            ...values.map((childId) => {
              const child = children.find(({ id: cid }) => cid === childId);
              return { id: childId, text: child.name, path: [id, childId] };
            }),
          );
        }

        searchFormPattern.setData({ field, label, value: resValues });
      };

      // const dropdownInstance = new MultipleDropdown({
      //   data: children.map(({ id, name }) => ({ value: id, name })),
      //   $input: $dorpdown,
      //   $reference: instance.$html,
      //   minWidth: "180px",
      //   onChange: (values) => setSearchFormPattern(values),
      // });

      instance.emitter.on("change", (checked) => setSearchFormPattern(checked ? [id] : []));

      return {
        instance,
        // dropdownInstance,
        setNumber,
      };
    });

    function setValue({ value = [] }) {
      const map = new Map(); // id => [ids]
      value.forEach(({ id, path }) => {
        const key = path[0];
        if (!map.has(key)) {
          map.set(key, []);
        }
        map.get(key).push(id);
      });

      checkboxInstances.forEach(({ instance, setNumber }) => {
        const id = instance.value;
        const values = map.get(id) || [];
        const children = specialData.find(({ id: _id }) => id === _id)?.children || [];
        instance.setValue(values.length > 0);
        if (values.length === 1 && values[0] === id) {
          // setNumber(children.length);
        } else {
          const _values = values.filter((v) => v !== id);
          // setNumber(_values.length);
        }
      });
    }

    return {
      $html: createFormItemLayout({
        field,
        label,
        formControlElement: checkboxInstances.map(({ instance }) => instance.$html),
      }),
      setValue,
    };
  }

  // 创建【裁判结果】表单组件
  function createResultTypeComponent(field) {
    const name = {
      result_type_0: "一审",
      result_type_1: "二审",
      result_type_2: "再审",
      result_type_3: "执行",
    }[field];
    const label = "裁判结果";
    const options = optionsMap[field];
    const checkboxInstance = new Checkbox({ label: name });
    const checkboxGroupInstance = new CheckboxGroup({ data: options });

    checkboxInstance.emitter.on("change", (checked) => {
      if (checked) {
        checkboxGroupInstance.setValue(options.map((d) => d.value));
        searchFormPattern.setData({
          field,
          label,
          value: options.map(({ value, name }) => ({ id: value, text: name })),
        });
      } else {
        checkboxGroupInstance.setValue([]);
        searchFormPattern.setData({
          field,
          label,
          value: [],
        });
      }
    });

    checkboxGroupInstance.emitter.on("change", (value) => {
      searchFormPattern.setData({
        field,
        label,
        value: value.map((id) => {
          const index = options.findIndex((d) => d.value === id);
          const text = options[index].name;
          return {
            id,
            text: text,
            index,
          };
        }),
      });
    });

    function setValue({ value = [] }) {
      if (value.length) checkboxInstance.setValue(true);
      else checkboxInstance.setValue(false);
      checkboxGroupInstance.setValue(value.map((item) => item.id));
    }

    return {
      $html: createFormItemLayout({
        field: "result_type",
        formControlElement: $('<div class="group-box">').append(
          checkboxInstance.$html,
          checkboxGroupInstance.$html,
        ),
      }),
      setValue,
    };
  }

  // 创建【案由】表单组件（输入框）
  function createReason2FormComponent() {
    const label = "案由";
    const field = "reason";

    const inputInstance = createSearchTagInput({
      field,
      label,
      placeholder: "支持首字母联想",
    });

    inputInstance.$inputBox.on("click", () =>
      showTreeTransferDialog({ label, field, data: reasonData }),
    );

    function setValue({ value = [] }) {
      inputInstance.setValue(value);
    }

    return {
      $html: createFormItemLayout({
        field,
        label,
        formControlElement: inputInstance.$inputBox,
      }),
      setValue,
    };
  }

  // 创建【引用法条】表单组件
  function createAllLawTextFormComponent() {
    const label = "引用法条";
    const field = "all_law_text";

    const inputInstance = createSearchTagInput({
      field,
      label,
      placeholder: "请输入引用法条，支持模糊查找",
    });

    inputInstance.$inputBox.on("click", () => showAllLawTextDialog());

    function setValue({ value = [] }) {
      inputInstance.setValue(value);
    }

    return {
      $html: createFormItemLayout({
        field,
        label,
        formControlElement: inputInstance.$inputBox,
      }),
      setValue,
    };
  }

  // 创建【地域】表单组件
  function createRegionFormComponent() {
    const label = "地域";
    const field = "region";
    const $rest = $('<div class="button-box"><i class="iconfont icon-refresh"></i>重置</div>');

    const inputInstance = createSearchTagInput({
      field,
      label,
      placeholder: "请选择",
    });

    const dropdownInstance = new CascaderDropdown({
      data: regionData,
      multiple: true,
      onlyLeaf: false,
      expandTrigger: "hover",
      $input: inputInstance.$inputBox,
      panelWidth: "200px",
      panelHeight: "380px",
      footerSlot: $rest,
    });

    dropdownInstance.emitter.on("change", (_value) => {
      const value = _value.map(({ id, name, path }) => ({ id, text: name, path }));
      searchFormPattern.setData({ field, label, value });
    });

    $rest.on("click", () => {
      searchFormPattern.setData({ field, label, value: [] });
    });

    function setValue({ value = [] }) {
      inputInstance.setValue(value);
      dropdownInstance.setValue(value.map(({ id, text, path }) => ({ id, path, name: text })));
    }

    return {
      $html: createFormItemLayout({
        field,
        label,
        formControlElement: inputInstance.$inputBox,
      }),
      setValue,
    };
  }

  // 创建【审理法院】表单组件
  function createCourtFormComponent() {
    const label = "审理法院";
    const field = "court";

    const inputInstance = createSearchTagInput({
      field,
      label,
      placeholder: "支持首字母联想",
    });

    inputInstance.$inputBox.on("click", () =>
      showTreeTransferDialog({ label, field, data: courtData }),
    );

    function setValue({ value = [] }) {
      inputInstance.setValue(value);
    }

    return {
      $html: createFormItemLayout({
        field,
        label,
        formControlElement: inputInstance.$inputBox,
      }),
      setValue,
    };
  }

  // 创建【当事人】表单组件
  function createDsrTagFormComponent() {
    const label = "当事人";
    const field = "dsr_tag";
    const $input = $('<div class="search-input-box dsr-tag">');
    const $number = $('<span class="search-input-number">');
    const $clear = $('<i class="search-input-clear iconfont icon-close-circle-filled">');
    const $content = $('<span class="search-input-content" placeholder="请输入">');

    const { $label: $sideLabel, setName: setSideName } = createDropdownLable({ label: "攻/守方" });
    const { $label: $typeLabel, setName: setTypeName } = createDropdownLable({
      label: "机构/个人",
    });

    const { instance: dsrTagInstance } = dsrTagDropDown($input);

    $clear.on("click", (e) => {
      e.stopPropagation();
      searchFormPattern.setData({ field, label, value: [] });
      dsrTagInstance.dropdownHide();
    });

    $input.append($sideLabel, $typeLabel, $content, $number, $clear);

    function setValue({ value = [] }) {
      const { side = "", type = "", text = "" } = value[0] || {};

      setSideName(getName(sideOptions, side) || "攻/守方");
      setTypeName(getName(typeOptions, type) || "机构/个人");
      $content.text(text);
      $number.text(value.slice(1).length || "");
      $clear[value.length ? "addClass" : "removeClass"]("hover-show");
    }

    return {
      $html: createFormItemLayout({
        field,
        label,
        formControlElement: $input,
      }),
      setValue,
    };
  }

  // 创建【公诉机关】【审判人员】【代理律师】【代理律所】表单组件
  function createMultipleInputFormComponent({ label, field, type }) {
    const inputHook = createSearchTagInput({
      field,
      label,
      placeholder: "支持首字母联想",
      useInput: true,
    });

    const $input = inputHook.$input;
    const $inputBox = inputHook.$inputBox;

    const dropdownHook = createAutocompleteDropdownProxy({
      field,
      label,
      $input: $inputBox,
      type,
    });

    const dropdownInstance = dropdownHook.dropdownInstance;
    const $dropdown = dropdownInstance.$html;

    $input.on("input", () => {
      const val = $input.val();
      if (val) {
        dropdownInstance.dropdownShow();
        dropdownHook.request(val);
      } else {
        dropdownInstance.dropdownHide();
        dropdownHook.request();
      }
    });

    $input.on("focus", () => {
      const val = $input.val();
      if (val) {
        dropdownHook.request(val);
        dropdownInstance.dropdownShow();
      }
    });

    dropdownHook.listEmitter.on("change", () => $input.val(""));

    document.addEventListener(
      "click",
      (e) => {
        if (
          $input.val() &&
          !dropdownInstance.isDescendant($dropdown[0], e.target) &&
          !dropdownInstance.isDescendant($inputBox[0], e.target)
        ) {
          $input.val("").trigger("input");
        }
      },
      true,
    );

    function setValue({ value = [] }) {
      inputHook.setValue(value);
      dropdownHook.setValue(value);
    }

    return {
      $html: createFormItemLayout({
        field,
        label,
        formControlElement: $inputBox,
      }),
      setValue,
    };
  }

  // 创建【标的额】表单组件
  function createBdeFormComponent() {
    const label = "标的额";
    const field = "bde";
    const { $label, setNumber } = createDropdownLable({ label });

    const options = [
      { value: "1", name: "0-10万", start: "0", end: "10" },
      { value: "2", name: "10-100万", start: "10", end: "100" },
      { value: "3", name: "100-500万", start: "100", end: "500" },
      { value: "4", name: "500-1000万", start: "500", end: "1000" },
      { value: "5", name: "1000万以上", start: "1000", end: "" },
      { value: "6", name: "" }, // 自定义
    ];

    const dropdownInstance = createAmountDropDwonProxy({
      field,
      label,
      $input: $label,
      options,
      trigger: "hover",
    });

    function setValue({ value }) {
      setNumber(value ? "1" : "");
      dropdownInstance.setValue(value);
    }

    return {
      $html: createFormItemLayout({
        field,
        formControlElement: $label,
      }),
      setValue,
    };
  }

  // 创建【罚金数额】表单组件
  function createFjseFormComponent() {
    const label = "罚金数额";
    const field = "fjse";
    const { $label, setNumber } = createDropdownLable({ label });

    const options = [
      { value: "1", name: "0-10万", start: "0", end: "10" },
      { value: "2", name: "10-100万", start: "10", end: "100" },
      { value: "3", name: "100-500万", start: "100", end: "500" },
      { value: "4", name: "500-1000万", start: "500", end: "1000" },
      { value: "5", name: "1000万以上", start: "1000", end: "" },
      { value: "6", name: "" }, // 自定义
    ];

    const dropdownInstance = createAmountDropDwonProxy({
      field,
      label,
      $input: $label,
      options,
      trigger: "hover",
    });

    function setValue({ value }) {
      setNumber(value ? "1" : "");
      dropdownInstance.setValue(value);
    }

    return {
      $html: createFormItemLayout({
        field,
        formControlElement: $label,
      }),
      setValue,
    };
  }

  // 创建【量刑情节】表单组件
  function createLxqjFormComponent() {
    const label = "量刑情节";
    const field = "lxqj";
    const $rest = $('<div class="button-box"><i class="iconfont icon-refresh"></i>重置</div>');
    const { $label, setNumber } = createDropdownLable({ label });

    const options = [
      { value: "3", name: "积极赔偿" },
      { value: "17", name: "胁从犯" },
      { value: "5", name: "自首" },
      { value: "1", name: "坦白" },
      { value: "6", name: "累犯" },
      { value: "7", name: "退赃退赔" },
      { value: "8", name: "从犯" },
      { value: "10", name: "犯罪未遂" },
      { value: "12", name: "立功" },
      { value: "14", name: "犯罪预备" },
      { value: "15", name: "犯罪中止" },
    ];

    const dropdownInstance = new MultipleDropdown({
      data: options,
      $input: $label,
      footerSlot: $rest,
      minWidth: "180px",
      trigger: "hover",
      onChange: (values) => {
        searchFormPattern.setData({
          field,
          label,
          value: values.map((id) => ({
            id,
            text: options.find((d) => d.value === id).name,
          })),
        });
      },
    });

    $rest.on("click", () => {
      searchFormPattern.setData({ field, label, value: [] });
    });

    function setValue({ value = [] }) {
      dropdownInstance.setValue(value.map(({ id }) => id));
      setNumber(value.length);
    }

    return {
      $html: createFormItemLayout({
        field,
        formControlElement: $label,
      }),
      setValue,
    };
  }

  // 创建【犯罪数额】表单组件
  function createFzseFormComponent() {
    const label = "犯罪数额";
    const field = "fzse";
    const { $label, setNumber } = createDropdownLable({ label });

    const options = [
      { value: "1", name: "0-10万", start: "0", end: "10" },
      { value: "2", name: "10-100万", start: "10", end: "100" },
      { value: "3", name: "100-500万", start: "100", end: "500" },
      { value: "4", name: "500-1000万", start: "500", end: "1000" },
      { value: "5", name: "1000万以上", start: "1000", end: "" },
      { value: "6", name: "" }, // 自定义
    ];

    const dropdownInstance = createAmountDropDwonProxy({
      field,
      label,
      $input: $label,
      options,
      trigger: "hover",
    });

    function setValue({ value }) {
      setNumber(value ? "1" : "");
      dropdownInstance.setValue(value);
    }

    return {
      $html: createFormItemLayout({
        field,
        formControlElement: $label,
      }),
      setValue,
    };
  }

  // 创建【篇幅】表单组件
  function createTextlenRangeFormComponent() {
    const label = "篇幅";
    const field = "textlen_range";
    const $rest = $('<div class="button-box"><i class="iconfont icon-refresh"></i>重置</div>');
    const { $label, setNumber } = createDropdownLable({ label });

    const options = Object.keys(textlenRangeData).map((str) => ({
      name: textlenRangeData[str],
      value: str,
    }));

    const dropdownInstance = new MultipleDropdown({
      data: options,
      $input: $label,
      footerSlot: $rest,
      minWidth: "180px",
      trigger: "hover",
      onChange: (values) => {
        searchFormPattern.setData({
          field,
          label,
          value: values.map((id) => ({
            id,
            text: options.find((d) => d.value === id).name,
          })),
        });
      },
    });

    $rest.on("click", () => {
      searchFormPattern.setData({ field, label, value: [] });
    });

    function setValue({ value = [] }) {
      setNumber(value.length);
      dropdownInstance.setValue(value.map(({ id }) => id));
    }

    return {
      $html: createFormItemLayout({
        field,
        formControlElement: $label,
      }),
      setValue,
    };
  }

  // 创建【审判年份】表单组件
  function createYearFormComponent() {
    const label = "审判年份";
    const field = "year";
    const $checkboxGroup = $('<div class="checkbox-group">');
    const $footer = $('<div class="multiple-dropdown-footer">');
    const $rest = $('<div class="button-box"><i class="iconfont icon-refresh"></i>重置</div>');

    const { $label, setNumber } = createDropdownLable({ label });

    const options = [...yearData.map((str) => ({ name: str, value: str })), { value: 1, name: "" }];

    const dropdownInstance = new DropDownProxy({
      $input: $label,
      minWidth: "150px",
      trigger: "hover",
      canHide: () => $(".layui-laydate").length === 0,
    });

    const getText = (start, end) => {
      if (start && end) {
        return `${start} ~ ${end}`;
      }
      return start || end || "";
    };

    const setJudgementValue = (isChecked, start, end) => {
      searchFormPattern.setData({
        field: "cprq",
        label: "审判年限",
        value: isChecked
          ? {
              id: "4",
              start: start,
              end: end,
              text: getText(start, end),
            }
          : null,
      });
    };

    const setYearValue = (isChecked, value) => {
      const allValues = searchFormPattern.getData(field)?.value || [];
      let resValues = [];
      if (isChecked) {
        resValues = [...allValues, { id: value, text: getText(value) }];
      } else {
        resValues = allValues.filter(({ id }) => id !== value);
      }

      searchFormPattern.setData({
        field,
        label: "审判年份",
        value: resValues,
      });
    };

    const checkboxInstances = options.map(({ name, value }) => {
      const isCustom = value === 1;

      const $start = $('<input type="text" readonly placeholder="开始时间">');
      const $end = $('<input type="text" readonly placeholder="结束时间">');
      const $confirm = $('<div class="button-box primary plan disabled">确定</div>');
      const $labelSlot = $('<div class="flex items-center" style="gap: 10px">')
        .append(
          $('<div class="input-picker-wrapper" style="width: 230px">').append(
            $('<div class="input-slot">').append($start),
            "-",
            $('<div class="input-slot">').append($end),
          ),
          $confirm,
        )
        .on("click", (e) => e.stopPropagation());

      const instance = new Checkbox({
        label: name,
        value: value,
        container: $checkboxGroup,
        readonly: isCustom,
        labelSlot: isCustom ? $labelSlot : undefined,
      });

      instance.emitter.on("change", (checked) => {
        if (!checked && isCustom) instance.setReadonly(true);

        if (isCustom) {
          setJudgementValue(checked, $start.val(), $end.val());
        } else {
          setYearValue(checked, value);
        }
      });

      $confirm.on("click", (e) => {
        e.stopPropagation();
        if ($confirm.hasClass("disabled")) return;

        if (new Date($start.val()) > new Date($end.val())) {
          $.message.warning("开始日期不能晚于结束日期");
          return;
        }

        instance.setReadonly(false);
        setJudgementValue(true, $start.val(), $end.val());
      });

      laydate.render({
        elem: $start[0],
        trigger: "click",
        max: createDateHtml(),
        done: (val) => {
          const isDisabled = !val && !$end.val();
          $confirm.toggleClass("disabled", isDisabled);
          isDisabled &&
            searchFormPattern.setData({
              field: "cprq",
              label: "审判年限",
              value: null,
            });
        },
      });

      laydate.render({
        elem: $end[0],
        trigger: "click",
        max: createDateHtml(),
        done: (val) => {
          const isDisabled = !val && !$start.val();
          $confirm.toggleClass("disabled", isDisabled);
          isDisabled &&
            searchFormPattern.setData({
              field: "cprq",
              label: "审判年限",
              value: null,
            });
        },
      });

      return {
        setValue: (yearValue, judgementValue) => {
          const isCustom = value === 1;
          const item = isCustom ? judgementValue : yearValue.find(({ id }) => id === value);
          const isChecked = !!item;
          const { start, end } = item || {};
          instance.setValue(isChecked);
          if (isCustom) {
            instance.setReadonly(!isChecked);
            $start.val(isChecked ? start : "");
            $end.val(isChecked ? end : "");
            $confirm.toggleClass("disabled", !$start.val() || !$end.val());
          }
        },
      };
    });

    dropdownInstance.$html.append(
      $('<div class="multiple-dropdown-content">').append(
        $('<div class="multiple-dropdown-body">').append($checkboxGroup),
        $footer.append($rest),
      ),
    );

    $rest.on("click", () => {
      searchFormPattern.setData({ field, label: "审判年份", value: [] });
      searchFormPattern.setData({ field: "judgement_timestamp", label: "审判年月", value: null });
    });

    function setValue({ value: yearValue = [] }, { value: judgementValue }) {
      checkboxInstances.forEach(({ setValue }) => setValue(yearValue, judgementValue));
      setNumber(yearValue.length + (judgementValue ? 1 : 0));
    }

    return {
      $html: createFormItemLayout({
        field,
        formControlElement: $label,
      }),
      setValue,
    };
  }

  // 创建【争议焦点】表单组件
  function createZyjdFormComponent() {
    const label = "争议焦点";
    const field = "zyjd";
    const $rest = $('<div class="button-box"><i class="iconfont icon-refresh"></i>重置</div>');
    const { $label, setNumber } = createDropdownLable({ label });

    const options = zyjdData.map(({ id, name }) => ({ name, value: id }));
    const allOptions = [...options];

    const assignSelectOptions = () => {
      const arr = [];
      const valueOptions = (searchFormPattern.getData(field)?.value || []).map(({ id, text }) => ({
        name: text,
        value: id,
      }));
      valueOptions.forEach((item) => {
        if (!options.some((d) => d.value === item.value)) {
          arr.push(item);
        }
      });
      return arr.concat(options);
    };

    const dropdownInstance = new MultipleDropdown({
      data: options,
      $input: $label,
      useFilter: true,
      footerSlot: $rest,
      minWidth: "180px",
      maxWidth: "250px",
      trigger: "hover",
      onChange: (values) => {
        searchFormPattern.setData({
          field,
          label,
          value: values.map((id) => ({
            id,
            text: [...assignSelectOptions(), ...allOptions].find((d) => d.value === id).name,
          })),
        });
      },
      filterCallback: async (keyword) => {
        if (!keyword) return assignSelectOptions();
        try {
          const res = await createFetch(
            "/Home/HighSearch/getDisputeFocus",
            { keyword },
            undefined,
            true,
          );
          const data = (res.data || []).map(({ id, name }) => ({ name, value: id }));
          allOptions.push(...data);
          return data;
        } catch (error) {
          return [];
        }
      },
    });

    $rest.on("click", () => {
      searchFormPattern.setData({ field, label, value: [] });
    });

    function setValue({ value = [] }) {
      dropdownInstance.setValue(value.map(({ id }) => id));
      setNumber(value.length);
    }

    return {
      $html: createFormItemLayout({
        field,
        formControlElement: $label,
      }),
      setValue,
    };
  }

  // 创建【基本案情】表单组件
  function createAjtzFormComponent() {
    const label = "基本案情";
    const field = "ajtz";
    const $rest = $('<div class="button-box"><i class="iconfont icon-refresh"></i>重置</div>');
    const { $label, setNumber } = createDropdownLable({ label });

    const options = ajtzData.map(({ id, name }) => ({ name, value: id }));
    const allOptions = [...options];

    const assignSelectOptions = () => {
      const arr = [];
      const valueOptions = (searchFormPattern.getData(field)?.value || []).map(({ id, text }) => ({
        name: text,
        value: id,
      }));
      valueOptions.forEach((item) => {
        if (!options.some((d) => d.value === item.value)) {
          arr.push(item);
        }
      });
      return arr.concat(options);
    };

    const dropdownInstance = new MultipleDropdown({
      data: options,
      $input: $label,
      useFilter: true,
      footerSlot: $rest,
      minWidth: "180px",
      maxWidth: "250px",
      trigger: "hover",
      onChange: (values) => {
        searchFormPattern.setData({
          field,
          label,
          value: values.map((id) => ({
            id,
            text: [...assignSelectOptions(), ...allOptions].find((d) => d.value === id).name,
          })),
        });
      },
      filterCallback: async (keyword) => {
        if (!keyword) return assignSelectOptions();
        try {
          const res = await createFetch(
            "/Home/HighSearch/getBasicCase",
            { keyword },
            undefined,
            true,
          );
          const data = (res.data || []).map(({ id, name }) => ({ name, value: id }));
          allOptions.push(...data);
          return data;
        } catch (error) {
          return [];
        }
      },
    });

    dropdownInstance.emitter.on("toggleShow", (isShow) => {
      if (isShow) {
        dropdownInstance.updateData(assignSelectOptions());
      }
    });

    $rest.on("click", () => {
      searchFormPattern.setData({ field, label, value: [] });
    });

    function setValue({ value = [] }) {
      dropdownInstance.setValue(value.map(({ id }) => id));
      setNumber(value.length);
    }

    return {
      $html: createFormItemLayout({
        field,
        formControlElement: $label,
      }),
      setValue,
    };
  }

  // // 创建表单组件 结构存在内部 返回
  // reason,
  // {
  //   getValue,
  //   setValue,
  //   emitter, // change()
  // },

  // // tag
  // {
  //   emitter, // change()
  //   update,
  // }

  // 已存模板
  function templateDropdown() {
    let listData = [];

    const dropdownInstance = new DropDownProxy({
      $input: $("#templateDropdown"),
      trigger: "click",
      placement: "bottom-end",
      placementFixed: true,
      minWidth: 600,
      maxWidth: 600,
    });

    const $html = $('<div class="template-dropdown-body">');
    const $content = $('<div class="template-dropdown-content">');
    const $setting = $('<i class="setting iconfont icon-Settings">');
    const $save = $('<div class="save button-box primary plan small">完成</div>');
    const $header = $('<div class="template-dropdown-header"><h3>已存模板</h3></div>').append(
      $('<div class="flex items-center">').append($setting, $save),
    );

    const renderItem = (item, index) => {
      const $tags = $('<div class="template-dropdown-tags">');

      const $inputWrapper = $('<div class="search-input-box" style="padding-right: 28px;">');
      const $clear = $('<i class="search-input-clear iconfont icon-close-circle-filled">');
      const $input = $(
        '<input class="input" maxlength="15" type="text" autocomplete="off" placeholder="请输入模板标题">',
      );
      const $count = $('<span class="search-input-count">0/15</span>');

      const $confirm = $('<span class="text-primary cursor-pointer">确定</span>');
      const $cancel = $('<span class="text-info cursor-pointer">取消</span>');
      const $edit = $('<i class="iconfont icon-edite" tooltip-content="重命名">').tooltip2();
      const $del = $('<i class="iconfont icon-delete" tooltip-content="删除模板">').tooltip2();

      const $title = $(`<div title="${item.focus_name}">`).text(item.focus_name);
      const $titleEditable = $("<div>").append(
        $inputWrapper.append($input, $clear),
        $count,
        '<span style="margin-left: 8px">',
        $confirm,
        '<span style="color: #DBDBDD">|</span>',
        $cancel,
      );

      const $actions = $("<div>").text(createDateHtml(item.create_time, "YYYY-MM-DD HH:mm"));
      const $actionsEditable = $("<div>").append($edit, $del);

      const $item = $('<div class="template-dropdown-item">').append(
        $(`<div class="template-dropdown-top">`).append(
          $('<div class="template-dropdown-title">').append($title, $titleEditable),
          $('<div class="template-dropdown-actions">').append($actions, $actionsEditable),
        ),
        $tags,
      );

      const formatUrl = (url = "", params = {}) => {
        const instance = new URL(
          url.replace(/([?&])TypeKey=([^&]*)/, function (match, prefix, value) {
            const formatted = value
              .replace(/:/g, "%3A")
              .replace(/=/g, "%3A")
              .replace(/ /g, "+")
              .replace(/\|#\|/g, "%7C%23%7C");

            return prefix + "TypeKey=" + formatted;
          }),
        );
        Object.entries(params).forEach(([key, value]) => {
          instance.searchParams.set(key, value);
        });
        return instance.href;
      };

      const renderTags = (item) => {
        let $html;
        if (keywordField.includes(item.field)) {
          $html = searchFormPattern.renderKeywordTagItem(item, undefined, true).$html;
        } else {
          $html = searchFormPattern.renderTagItem(item, undefined, true).$html;
        }
        return $html;
      };

      const formData = SearchListParams.getHighSearchParams({
        url: new URL(formatUrl(item.content, { search_uuid: item.search_uuid })),
        searchCondition: item.search_con,
      });

      $tags.append(
        formData
          .flatMap((item) => {
            if (item.field === "gjjs")
              return item.value.flat(Infinity).filter((item) => item.field);
            else return item;
          })
          .sort((a, b) => {
            if (keywordField.includes(a.field) && keywordField.includes(b.field)) return 0;
            if (keywordField.includes(a.field)) return -1;
            if (keywordField.includes(b.field)) return 1;
            return 0;
          })
          .map(renderTags),
      );

      $clear.on("click", () => $input.val("").trigger("input"));
      $input.on("input", () => {
        $clear.toggleClass("hover-show", !!$input.val());
        $count.text(`${$input.val().length}/15`);
      });
      $edit.on("click", () => {
        $item.addClass("editing");
        $input.val($title.text()).trigger("input");
      });
      $del.confirm({
        content: "您确定要删除此方案吗？",
        placement: "bottom-end",
        minWidth: 174,
        maxWidth: 174,
        onConfirm: async () => {
          listData.splice(index, 1);
          $item.remove();
          await createFetch("/Home/User/DeleteHistoryDown", { id: item.id, type: "search" });
          if (listData.length === 0) {
            $("#templateDropdown").hide();
            dropdownInstance.dropdownHide();
          }
        },
      });
      $cancel.on("click", () => {
        $item.removeClass("editing");
        $actionsEditable.show();
      });
      $confirm.on("click", () => {
        const val = $input.val();
        if (!val.length) return $.message.warning("请输入模板标题");
        else if (val.length > 15) return $.message.warning("模板标题不超过15个字符");
        $item.removeClass("editing");
        $title.text(val).attr("title", val);
        item.focus_name = val;
        createFetch("/Home/Focus/updateFocus", { id: item.id, focus_name: val });
      });

      $item.on("click", () => {
        if ($html.hasClass("editable")) return;
        window.open(formatUrl(item.content, { search_uuid: item.search_uuid }), "_blank");
      });

      return $item;
    };

    const request = async () => {
      const { focus_list: list = [], count = 0 } = await createFetch(
        "/Home/Focus/showFocus",
        { type: "case", page: 1, pagesize: 9999999 },
        undefined,
        true,
      );
      listData = list;
      $content.empty();
      list.forEach((item, index) => $content.append(renderItem(item, index)));

      if (count) $("#templateDropdown").show();
    };

    const initialize = () => {
      $html.removeClass("editable");
      $html.find(".template-dropdown-item").removeClass("editing");
      request();
    };

    $setting.on("click", () => $html.addClass("editable"));

    $save.on("click", () => {
      $html.removeClass("editable");
      $html.find(".template-dropdown-item").removeClass("editing");
    });

    dropdownInstance.$html.append($html.append($header, $content));
    dropdownInstance.emitter.on("toggleShow", (isShow) => isShow && initialize());

    initialize();

    return dropdownInstance;
  }

  const init = () => {
    $("#searchFormSlideDown").on("click", () => {
      $("#searchFormWrap").toggleClass("slide-down");
    });

    $("#searchFormRest").on("click", () => {
      if (window.location.href.indexOf("gjss") > -1) {
        sessionStorage.removeItem("child");
        sessionStorage.removeItem("datainfo");
        sessionStorage.removeItem("highlight");
        sessionStorage.removeItem("keywordshow");
        sessionStorage.removeItem("SessionBack");
        location.search = "?TypeKey=";
      } else {
        searchFormPattern.rest({ directEmitter: true });
      }
    });

    $("#searchFormSave").on("click", async () => {
      const formData = searchFormPattern.getData();
      await createFetch("/Home/Focus/checkFocus", {
        focus_name: "ff",
        keyword: `案例搜索：` + SearchListParams.getParamKeyword(formData),
        search_uuid: getQueryString("search_uuid"),
      });

      showSaveTemplateDialog();
    });

    if (window.location.href.indexOf("gjss") == -1) {
      searchFormPattern.register("reason", createReasonFormComponent());
      searchFormPattern.register("judgement", createJudgementFormComponent());
      searchFormPattern.register("case_level", createCaseLevelFormComponent());
      searchFormPattern.register("cprq", createCprqFormComponent());
      searchFormPattern.register("round", createRoundFormComponent());
      searchFormPattern.register("court_level", createCourtLevelFormComponent());
      searchFormPattern.register("special", createSpecialFormComponent());
      searchFormPattern.register("result_type_0", createResultTypeComponent("result_type_0"));
      searchFormPattern.register("result_type_1", createResultTypeComponent("result_type_1"));
      searchFormPattern.register("result_type_2", createResultTypeComponent("result_type_2"));
      searchFormPattern.register("result_type_3", createResultTypeComponent("result_type_3"));
      searchFormPattern.register("_reason", createReason2FormComponent());
      searchFormPattern.register("all_law_text", createAllLawTextFormComponent());
      searchFormPattern.register("region", createRegionFormComponent());
      searchFormPattern.register("court", createCourtFormComponent());
      searchFormPattern.register("dsr_tag", createDsrTagFormComponent());
      searchFormPattern.register(
        "prosecution_org_tags",
        createMultipleInputFormComponent({
          label: "公诉机关",
          field: "prosecution_org_tags",
          type: "公诉机关",
        }),
      );
      searchFormPattern.register(
        "judge_tags",
        createMultipleInputFormComponent({ label: "审判人员", field: "judge_tags", type: "法官" }),
      );
      searchFormPattern.register(
        "lawyer_tags",
        createMultipleInputFormComponent({ label: "代理律师", field: "lawyer_tags", type: "律师" }),
      );
      searchFormPattern.register(
        "lawoffice_tags",
        createMultipleInputFormComponent({
          label: "代理律所",
          field: "lawoffice_tags",
          type: "律所",
        }),
      );
      searchFormPattern.register("bde", createBdeFormComponent());
      searchFormPattern.register("fjse", createFjseFormComponent());
      searchFormPattern.register("lxqj", createLxqjFormComponent());
      searchFormPattern.register("fzse", createFzseFormComponent());
      searchFormPattern.register("textlen_range", createTextlenRangeFormComponent());
      searchFormPattern.register("year", createYearFormComponent());
      searchFormPattern.register("zyjd", createZyjdFormComponent());
      searchFormPattern.register("ajtz", createAjtzFormComponent());

      templateDropdown();

      searchFormPattern.emitter.on("change", async (fieldData) => {
        const titlePrefix = fieldData
          .filter((item) => keywordField.includes(item.field))
          .flatMap((item) => item.value)
          .join(" ");

        if (titlePrefix) document.title = `${titlePrefix}_查案例`;
        else document.title = "查案例";

        const len = fieldData.length;
        const data = SearchListParams.getParams({ only_num: true, default_case_level: [] });
        const _ = await createFetch("/Home/search/searchJson", { ...data, getcasenum: true }, undefined, true);
        const result = _.info
        // 变更新的uuid
        var url = window.location.href
        if (window.location.href.indexOf('search_uuid') != -1) {
          url = self.funcUrlDel('search_uuid')
        }
        window.History.pushState(null, document.title, url + '&search_uuid=' + _.search_uuid)


        $(".search_form_title_total").toggle(!!len);
        $("#searchFormTitleSign").text(result.sign_type != 2 ? "模糊" : "精确");

        console.log("result.count", result);

        let count = result.count;
        let unit = "";
        let separator = "";
        if (count >= 100000000) {
          count = Math.floor((count / 100000000) * 100) / 100;
          unit = "亿";
        } else if (count >= 10000) {
          count = Math.floor((count / 10000) * 100) / 100;
          unit = "万";
        } else {
          separator = ",";
        }
        $("#searchFormTitleUnit").text(unit);
        $("#searchFormTitleTotal").attr("data-count", result.count);
        countNumber($("#searchFormTitleTotal")[0], 0, count, separator);
      });

      $(".search_form_title, .search_form_wrap").show();
    }
  };

  init();

  // --------------- utils --------------- //

  function cloneDeep(obj) {
    try {
      return JSON.parse(JSON.stringify(obj));
    } catch (e) {
      return obj;
    }
  }

  function createDateHtml(date, format = "YYYY-MM-DD") {
    const d = date ? new Date(date) : new Date();
    if (isNaN(d.getTime())) return "";

    const formatMap = {
      YYYY: d.getFullYear(),
      MM: (d.getMonth() + 1).toString().padStart(2, "0"),
      DD: d.getDate().toString().padStart(2, "0"),
      HH: d.getHours().toString().padStart(2, "0"),
      mm: d.getMinutes().toString().padStart(2, "0"),
      ss: d.getSeconds().toString().padStart(2, "0"),
    };

    return format.replace(/YYYY|MM|DD|HH|mm|ss/g, (match) => formatMap[match]);
  }
});

const getParentUrlstr = () => {
  try {
    return window.parent?.urlStr || ""
  } catch (e) {
    return ""
  }
}

const createFetch = (url, data, baseURL, noValidate = false) => {
  baseURL = baseURL ?? getParentUrlstr()
  return new Promise((resolve, reject) => {
    $.ajax({
      url: baseURL + url,
      type: "post",
      data,
      dataType: "json",
      success: function (result) {
        if (noValidate) return resolve(result);

        if (result.code == 0 || result.code == 200) {
          resolve(result.info);
        } else {
          reject(result.info || result.msg);
          $.message.error(result.info || result.msg);
        }
      },
      error: function () {
        reject("请求失败，请检查网络或联系管理员");
        $.message.error("请求失败，请检查网络或联系管理员");
      },
    });
  });
};

function countNumber(id, begin, end, separator = "") {
  var easingFn = function (t, b, c, d) {
    var ts = (t /= d) * t;
    var tc = ts * t;
    return b + c * (tc * ts + -5 * ts * ts + 10 * tc + -10 * ts + 5 * t);
  };

  var options = {
    useEasing: true,
    easingFn: easingFn,
    useGrouping: true,
    separator: separator,
    decimal: ".",
    prefix: "",
    suffix: "",
  };
  var demo = new CountUp(id, begin, end, end % 1 == 0 ? 0 : 2, 1, options);
  demo.start();
}
